import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import { EventEmitter, Injectable } from '@angular/core'
import { environment } from 'src/environments/environment'
import { AccountModel, ParamsConfig } from './account'

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  private accountList$: Observable<any> | null = null
  public accountListEventEmmiter: EventEmitter<any> =
    new EventEmitter()
  public accountToEdit: any = {} 

  constructor(
    private httpClient: HttpClient
    ) {}

  public clearCacheAccountList(): void {
    this.accountList$ = null
    this.getAllAccounts({
      page: 1,
      page_size: 10,
      term: '',
      ativo: 'true',
      filter: []
    })
  }

  public getAllAccounts(objParams?:ParamsConfig): void {

    if(objParams) {

      let params = new HttpParams()
      .set('page', objParams.page)
      .set('page_size', objParams.page_size)
      .set('term', objParams.term)
      .set('ativo', objParams.ativo || '')
      .set('tags', objParams.filter?.join(",") || '');

      if (objParams.ativo && objParams.ativo !== "all") {
        params = params.set("ativo", objParams.ativo.toString());
      }

      
      if (objParams.orderBy) {
        params = params.set('orderBy', objParams.orderBy);
      }
      if (objParams.orderDir) {
        params = params.set('orderDir', objParams.orderDir);
      }

      this.accountList$ = this.httpClient
        .get<any>(environment.apiUrl + '/admin/contas', {params})

    }else{

      const params = {
        page: 1,
        page_size: 10
      }

      this.accountList$ = this.httpClient
        .get<any>(environment.apiUrl + '/admin/contas', {params})

    }

    this.accountList$.subscribe((data) => {
      this.accountListEventEmmiter.emit(data)
    })
  }

  public getAccount(id: number) {

    return this.httpClient
        .get<any>(environment.apiUrl + '/admin/'+id);
  }

  public deleteAccount(id: string) {
    return this.httpClient.delete<any>(
        environment.apiUrl + '/admin/' + id
    )
  }

  public toggleAccountActivation(id: number, action:string) {
    return this.httpClient.put<any>(
        environment.apiUrl + '/admin/toggle-activation/' + id, {action}
    )
  }

  public ownerAccess(id:number) {
    return this.httpClient.get<any>(environment.apiUrl + '/admin/owner_access/'+id)
  }

  public setOonIntegration(id: number, enabled: boolean) {
    return this.httpClient.put<AccountModel>(
        environment.apiUrl + '/admin/contas/' + id + '/oon-integration', {enabled}
    )
  }

  public saveNewAccount(account: AccountModel) {
    return this.httpClient.post<AccountModel>(
      environment.apiUrl + '/admin/contas',
      account
    )
  }

  public editAccount(account: AccountModel, idAccount: string) {
    return this.httpClient.put<AccountModel>(
      environment.apiUrl + '/admin/' + idAccount,
      account
    )
  }

  

  public getUsersList(id: number) {

    return this.httpClient
        .get<any>(environment.apiUrl + '/admin/usuarios/'+id);
        
  }

  saveNewUser(user:any){
    return this.httpClient
    .post<any>(environment.apiUrl + '/admin/user', user);
  }

  editUser(userModel:any, id:number) {
    return this.httpClient
    .put<any>(environment.apiUrl + '/admin/user/'+id, userModel);
  }
  
  deleteUser(id: number) {
    return this.httpClient.delete<any>(
        environment.apiUrl + '/admin/user/'+id)

  }

  

  public uploadLogo(file: File, accountId: any) {
    const formData = new FormData();
    formData.append('file', file);

    return this.httpClient.post(
      `${environment.apiUrl}/admin/account/${accountId}/upload-logo`,
      formData
    );
  }

  public getLogo(accountId: any): Observable<{ logo_base64: string }> {
    return this.httpClient.get<{ logo_base64: string }>(`${environment.apiUrl}/admin/account/${accountId}/logo`);
  }

  public removeLogo(accountId: any): Observable<any> {
    return this.httpClient.delete(`${environment.apiUrl}/admin/account/${accountId}/logo`);
  }

}
